import React from 'react'
import image1 from '../images/gala1.jpeg'
import image2 from '../images/gala2.jpeg'
import image3 from '../images/gala3.jpeg'
import image4 from '../images/gala4.jpeg'
import image5 from '../images/gala5.jpeg'
import image6 from '../images/gala6.jpeg'
import image7 from '../images/gala7.jpeg'
import image8 from '../images/gala8.jpeg'
import image9 from '../images/gala9.jpeg'
import image10 from '../images/gala10.jpeg'
import image11 from '../images/gala11.jpeg'

export default function Gala() {
  return (
    <div className='sub-gallery-images'>
      <img src={image1} alt='photo' className='sub-gallery-image'/>
      <img src={image2} alt='photo' className='sub-gallery-image'/>
      <img src={image3} alt='photo' className='sub-gallery-image'/>
      <img src={image4} alt='photo' className='sub-gallery-image'/>
      <img src={image5} alt='photo' className='sub-gallery-image'/>
      <img src={image6} alt='photo' className='sub-gallery-image'/>
      <img src={image7} alt='photo' className='sub-gallery-image'/>
      <img src={image8} alt='photo' className='sub-gallery-image'/>
      <img src={image9} alt='photo' className='sub-gallery-image'/>
      <img src={image10} alt='photo' className='sub-gallery-image'/>
      <img src={image11} alt='photo' className='sub-gallery-image'/>
    </div>
  )
}
